var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 width-100 height-100 marketplace-container pb-8"},[_c('div',{staticClass:"page-title-text mt-9"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('FlowsView',{staticClass:"pb-8",attrs:{"filter-by":_vm.filterBy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }